/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'

export default {
  getAllSubCategorias ({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/sub-categoria', {
          headers: {
            Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
          }
        })
        .then(response => {
          console.log('SubCategorias ', response.data)
          commit('SET_SUBCATEGORIAS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
